import React, { useEffect, useState, useContext } from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Input,
    Textarea,
    Button,
    Image,
    VStack,
    HStack,
    FormControl,
    FormLabel,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Select
} from "@chakra-ui/react";
import { FaCamera, FaFileUpload, FaTrash } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";

const CreateTicketModal = ({ isOpen = false, onClose = () => {}, handleCreateTicket = () => {} }) => {
    const [formData, setFormData] = useState({ name: "", description: "", sectionId: "", image: null });
    const [previewUrl, setPreviewUrl] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { sections } = useContext(AuthContext);

    useEffect(() => {
        if (isOpen) {
            setFormData({ name: "", description: "", sectionId: "", image: null });
            setPreviewUrl("");
        }
    }, [isOpen]);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData(prev => ({ ...prev, image: file }));
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleRemoveImage = () => {
        setFormData(prev => ({ ...prev, image: null }));
        setPreviewUrl("");
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await handleCreateTicket(formData);
            onClose();
        } catch (error) {
            console.error("Error creating ticket:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Dodajte novi zadatak</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <VStack spacing={4} align="stretch">
                        <FormControl>
                            <FormLabel>Naziv zadatka</FormLabel>
                            <Input
                                placeholder="Upišite naziv zadatka"
                                value={formData.name}
                                onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Opis</FormLabel>
                            <Textarea
                                placeholder="Upišite opis zadatka"
                                value={formData.description}
                                onChange={(e) => setFormData(prev => ({ ...prev, description: e.target.value }))}
                            />
                        </FormControl>

                        <FormControl>
                            <FormLabel>Odaberite odjeljak</FormLabel>
                            <Select
                                placeholder="Odabir odjeljka"
                                value={formData.sectionId}
                                onChange={(e) => setFormData(prev => ({ ...prev, sectionId: e.target.value }))}
                            >
                                {sections.map((section) => (
                                    <option key={section.id} value={section.id}>{section.name}</option>
                                ))}
                            </Select>
                        </FormControl>

                        <FormControl isRequired>
                            <FormLabel>Učitaj sliku</FormLabel>
                            <Menu>
                                <MenuButton as={Button} rightIcon={<FaFileUpload />} width="100%">
                                    Odaberite sliku ili otvorite kameru
                                </MenuButton>
                                <MenuList width="100%">
                                    <MenuItem icon={<FaFileUpload />} onClick={() => document.getElementById("fileInput").click()}>
                                        Odaberite sliku
                                    </MenuItem>
                                    <MenuItem icon={<FaCamera />} onClick={() => document.getElementById("cameraInput").click()}>
                                        Slikaj fotografiju
                                    </MenuItem>
                                </MenuList>
                            </Menu>
                            <Input
                                id="fileInput"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                                display="none"
                            />
                            <Input
                                id="cameraInput"
                                type="file"
                                accept="image/*"
                                capture
                                onChange={handleFileChange}
                                display="none"
                            />
                            {previewUrl && (
                                <VStack mt={2} spacing={2} align="start">
                                    <Image
                                        src={previewUrl}
                                        alt="Image preview"
                                        boxSize="100px"
                                        objectFit="cover"
                                        borderRadius="md"
                                    />
                                    <Button leftIcon={<FaTrash />} colorScheme="red" size="sm" onClick={handleRemoveImage}>
                                        Ukloni sliku
                                    </Button>
                                </VStack>
                            )}
                        </FormControl>
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <HStack spacing={4}>
                        <Button 
                            colorScheme="blue" 
                            onClick={handleSubmit} 
                            isDisabled={
                                isSubmitting ||
                                !formData.sectionId ||
                                !formData.description||
                                !formData.name ||
                                !formData.image
                            }
                        >
                            {isSubmitting ? "Dodavanje..." : "Dodaj zadatak"}
                        </Button>
                        <Button onClick={onClose}>Povratak</Button>
                    </HStack>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default CreateTicketModal;
